// extracted by mini-css-extract-plugin
module.exports = {"photo":"photo_photo__1m3jq"};